import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { useIntl, FormattedMessage } from 'react-intl';
import { TagIcon } from '~/modules/common/components/Icons';
import useStyles from './useStyles';

const TagsIndicator = ({ value }) => {
  const classes = useStyles();
  const intl = useIntl();
  const values = useMemo(
    () => ({
      count: value.length
    }),
    [value.length]
  );

  if (value.length === 0) return null;

  return (
    <span
      className={classes.root}
      aria-label={intl.formatMessage({ id: 'resourceRequestCard.tags' })}
    >
      <Tooltip title={intl.formatMessage({ id: 'resourceRequestCard.tags' })}>
        <TagIcon className={classes.icon} />
      </Tooltip>
      <FormattedMessage
        id={
          value.length > 1
            ? 'resourceRequestCard.tagRequirements'
            : 'resourceRequestCard.tagRequirement'
        }
        values={values}
      />
    </span>
  );
};

TagsIndicator.propTypes = {
  value: PropTypes.array
};

export default TagsIndicator;
